import React, { useState } from "react";
import PageWrapper from "../../Components/Other/PageWrapper";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { routes } from "../../MainPage";
import { useDispatch, useSelector } from "react-redux";
import { CommonApiFun } from "../../Redux/Action/index";

function DoctorInfo(props) {
  let { name } = useParams();
  let navigate = useNavigate();
  var TeamArr1 = useSelector((state) => state.TeamArr);
  const [data, setData] = useState(TeamArr1.lenghth != 0 ? TeamArr1[name] : "");
  const dispatch = useDispatch();
  useEffect(() => {
    var datacheck = TeamArr1.lenghth != 0 ? TeamArr1[name] : "";
    if (typeof datacheck === "undefined") {
      if (name == "jayesh-ghadiya") {
        getData();
      } else {
        navigate(routes.team);
      }
    }
    if (datacheck == "") {
      alert("fklsdf");
      var data = { action: "team" };
      dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data)))
        .then((res) => {
          dispatch({ type: "TEAM_DATA", payload: res.data });
          if (name == "jayesh-ghadiya") {
            getData();
          }
        })
        .catch((e) => {});
    }
  }, []);

  const getData = () => {
    var index = TeamArr1.findIndex(
      (item) => (item.name.toUpperCase() === "Dr Jayesh Ghadiya".toUpperCase()|| item.name.toUpperCase() === "Dr. Jayesh Ghadiya".toUpperCase()||item.name.toUpperCase() === "Jayesh Ghadiya".toUpperCase())
    );
    setData(TeamArr1[index]);

  };
  return (
    <PageWrapper className={"doctors-team-pag"}>
      <div className="pageWrapper">
        <div className="web-sect pageBox">
          <div className="pageBanner">
            <div className="page-banner-wrap">
              <div className="pageWrapperItem">
                <img
                  src={require("../../img/banner-bg.png")}
                  alt="Page Banner"
                />
                {data && (
                  <div className="pageBanner-text">
                    <div className="container">
                      <div className="pageBanner-content">
                        <h1>{data ? data.name : " "}</h1>
                        <div className="breadcrumbs">
                          <div className="container">
                            <ul className="list-inline listUnstyle">
                              <li>
                                <a
                                  href={routes.home}
                                  onClick={() => navigate(routes.home)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 32 32"
                                  >
                                    <path d="m21.82 30h-11.64a5 5 0 0 1 -5.18-4.76v-6.24a1 1 0 0 1 2 0v6.24a3 3 0 0 0 3.18 2.76h11.64a3 3 0 0 0 3.18-2.76v-6.24a1 1 0 0 1 2 0v6.24a5 5 0 0 1 -5.18 4.76zm7.89-13.29a1 1 0 0 0 0-1.42l-13-13a1 1 0 0 0 -1.42 0l-13 13a1 1 0 0 0 1.42 1.42l12.29-12.3 12.29 12.3a1 1 0 0 0 1.42 0z" />
                                  </svg>
                                  Home
                                </a>
                              </li>
                              <li>
                                <a
                                  href={routes.team}
                                  onClick={() => navigate(routes.team)}
                                >
                                  Team
                                </a>
                              </li>
                              <li>
                                <span>{data ? data.name : " "}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="MainContent">
          <div className="team-page">
            <div className="container">
              {data && (
                <div className="text-img-block">
                  <div className="text-column">
                    <div className="image_block">
                      <div className="img-links">
                        <img src={data.profile_image} alt={data.name} />
                      </div>
                    </div>
                  </div>
                  <div className="text-column">
                    <h2>{data.name}</h2>
                    <p><b>{data.qualifications}</b></p>
                    {JSON.parse(data.description).map((descriptionItem) => {
                      return <p>{descriptionItem}</p>;
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default DoctorInfo;
